<a id="btnWhatsApp"  (click)="onWhatsAppButtonClick()">
  <button mat-button class="Btn BtnBorder">
    <span class="material-icons align-middle">perm_phone_msg</span>
    {{this.textWhatsApp}}
  </button>
</a>